import React from "react"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { MenuItem } from "@mui/material"
import { BusinessType, EntityFormValues } from "../../supportEntitiesTypes"

export function EntityTypeSelect() {
    return (
        <LocalizedStrict id="support-create-entity-type-label" attrs={{ label: true }}>
            <FormikDropdown<EntityFormValues> fullWidth name="businessType" label="Type">
                <MenuItem value={BusinessType.PRIVATE_COMPANY}>
                    <LocalizedStrict id="support-create-entity-dropdown-private-company">
                        <span>Private company</span>
                    </LocalizedStrict>
                </MenuItem>
                <MenuItem value={BusinessType.PRIVATE_PERSON}>
                    <LocalizedStrict id="support-create-entity-dropdown-private-person">
                        <span>Private person</span>
                    </LocalizedStrict>
                </MenuItem>
                <MenuItem value={BusinessType.PUBLIC_LIMITED_COMPANY}>
                    <LocalizedStrict id="support-create-entity-dropdown-public-limited-company">
                        <span>Public limited company</span>
                    </LocalizedStrict>
                </MenuItem>
            </FormikDropdown>
        </LocalizedStrict>
    )
}
